import React from "react";
import { makeStyles } from "@mui/styles";
import { SpeedDial, SpeedDialAction } from "@mui/material";
import PropTypes from "prop-types";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ClearIcon from "@mui/icons-material/Clear";
import { Typography } from "@mui/material";
import type { Theme } from "@mui/material/styles";

const speedDialButtonSx = (theme: Theme) => ({
	backgroundColor:
		theme.palette.mode === "dark" ? theme.palette.background.paper : theme.palette.common.black,
	border:
		theme.palette.mode === "dark" ? `1px solid ${theme.palette.action.active}` : "none",
	boxShadow: theme.palette.mode === "dark" ? "none" : undefined,
	color:
		theme.palette.mode === "dark" ? theme.palette.text.primary : theme.palette.common.white,
	"&:hover": {
		backgroundColor:
			theme.palette.mode === "dark" ? theme.palette.grey[800] : theme.palette.common.black,
		borderColor:
			theme.palette.mode === "dark" ? theme.palette.text.primary : theme.palette.common.black,
		boxShadow: theme.palette.mode === "dark" ? "none" : undefined,
	},
});

const speedDialActionSx = (theme: Theme) => ({
	...speedDialButtonSx(theme),
	margin: theme.palette.mode === "dark" ? 0 : theme.spacing(0.25),
});

const useStyles = makeStyles((theme) => ({
	speedDial: {
		position: "fixed",
		bottom: theme.spacing(1),
		right: theme.spacing(1),
		alignItems: "flex-end",
	},
	speedDialAction: {
		minWidth: 190,
		minHeight: 40,
		fontSize: 20,
		textTransform: "capitalize",
		...theme.shape,
	},
}));

export default function SpeedDialMenu(props) {
	const { isOpen, actions, onOpen, onClose } = props;
	const classes = useStyles();

	return (
		<SpeedDial
			ariaLabel="SpeedDialMenu"
			className={classes.speedDial}
			onOpen={onOpen}
			onClose={onClose}
			icon={isOpen ? <ClearIcon /> : <MoreVertIcon />}
			open={isOpen}
			FabProps={{ sx: speedDialButtonSx }}
		>
			{actions.map(
				(action) =>
					action.isDisplay && (
						<SpeedDialAction
							key={actions.findIndex((a) => a.title === action.title)}
							title={action.title}
							icon={<Typography variant="body1">{action.title}</Typography>}
							onClick={action.onClick}
							className={classes.speedDialAction}
							slotProps={{ fab: { sx: speedDialActionSx } }}
							disableHoverListener
							disableTouchListener
							disableFocusListener
						/>
					)
			)}
		</SpeedDial>
	);
}

SpeedDialMenu.propTypes = {
	isOpen: PropTypes.bool,
	onOpen: PropTypes.func,
	onClose: PropTypes.func,
	actions: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string,
			onClick: PropTypes.func.isRequired,
			isDisplay: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
		})
	).isRequired,
};
